import { render, staticRenderFns } from "./AdminAccompagnement.vue?vue&type=template&id=c28d9cea&"
import script from "./AdminAccompagnement.vue?vue&type=script&lang=js&"
export * from "./AdminAccompagnement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports